import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import client from 'src/utils/client'
import { Slot } from './Type'

export const syncBookableSlots = createAsyncThunk<
  Slot[],
  {
    assetId: string
    agent?: string
  },
  { rejectValue: { code: number } }
>('bookable/syncBookableSlots', async ({ assetId, agent }, { rejectWithValue }) => {
  return client<Slot[]>(URLS.PUBLIC_BOOKABLE_SLOTS(assetId, agent)).catch((err) => {
    return rejectWithValue(err)
  })
})
